var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-08-/-checkmark-/-solid",
    transform: "translate(0.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LUI-icon-pd-checkmark-solid-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.17,6.7 L0,4.59 L1.46,3.16 L2.9,4.57 L6.54,1 L8,2.43 L3.62,6.7 C3.43120604,6.89873082 3.16911147,7.01125113 2.895,7.01125113 C2.62088853,7.01125113 2.35879396,6.89873082 2.17,6.7 Z",
    id: "---\\u21B3-\\uD83C\\uDF08-Color",
    fillOpacity: 0.8,
    fill: "#9B9B9B"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.526b5af8dc1965e9745bc71ea801662f.svg";
export { ForwardRef as ReactComponent };